





































































import {
  Component,
  Vue,
  Watch
} from "vue-property-decorator";
import menu from '../menu';

@Component({

})
export default class pc extends Vue {
  private defaultActive: string = menu[0].path
  private userInfo: any = {}
  private dialogVisible: boolean = false
  private ruleForm: any = {}
  private rules: any = {
    password: [{
      required: true,
      message: '请输入原密码',
      trigger: 'blur'
    }, ],
    newPwd: [{
      required: true,
      message: '请输入新密码',
      trigger: 'blur'
    }, ],
  }

  // private handleSelect (index, path) {
  // }
  public mounted() {
    this.defaultActive = this.$route.path;
    this.userInfo = JSON.parse((sessionStorage.getItem('userToken') as string));
  }

  @Watch('$route')
  onRouteChanged(nVal: any) {
    this.defaultActive = nVal.path;
  }

  private get menuList () {
    return menu
  }
  private show (route:any) {
    // return !route.meta.access ||route.meta.access.includes(this.userInfo.userAccount)
    return route.meta.access.includes(this.userInfo.scope)
  }

  private dropdownHandle(v:string) {
    if (v === 'out') {
      this.logout();
    } else if (v === 'pwd') {
      this.dialogVisible = true
      this.ruleForm = {
        password: '',
        newPwd: ''
      }
    }
  }
  private logout() {
    sessionStorage.removeItem('userToken')
    this.$router.push({
      name: 'login'
    })
  }
  private submitForm(formName:string) {
    (this.$refs[formName] as any).validate((valid:any) => {
      if (valid) {
        this.$axios({
          url: '/pc/user/modifyPwd',
          method: 'POST',
          data: {
            userAccount: JSON.parse((sessionStorage.getItem('userToken') as string)).userAccount,
            ...this.ruleForm
          }
        }).then((res:any) => {
          if (res.success) {
            this.$message({
              message: res.message,
              type: 'success'
            });
            (this.$refs[formName] as any).resetFields();
            this.dialogVisible = false
            this.logout();
          } else {
            this.$message.error(res.message);
          }
        })
      } else {
        return false;
      }
    });
  }
}
